<template>
  <div
    v-show="isRegProgressShown"
    class="registration-wizard"
  >

    <!-- Registration Setup Progress -->
    <section class="registration-wizard-count">
      <strong>
        <span>
          {{ $lang.messages.regAccountProgress }}
        </span>
          <span>
          ({{ this.currentStep }} {{ $lang.messages.Of }} {{ this.totalSteps }} )
        </span>
      </strong>
    </section>
  
    <img src="@/assets/images/pocket-left.png" alt="before" class="pocket">
    <section class="registration-wizard-steps-wrapper" ref="steps">
      <!-- Invite Co-parent -->
      <reg-steps-box
        :text="$lang.messages.invTheCoparent"
        :whatStep="coparentAdded"
        :isShown="true"
        :isDisabledClass="false"
      >
      </reg-steps-box>

      <!-- Add children -->
      <reg-steps-box
        :text="$lang.messages.addChildren"
        :whatStep="childAdded"
        :isShown="childAdded"
        :isDisabledClass="childAdded === 'unfinished'"
      >
      </reg-steps-box>
  
      <!-- Add your subscription -->
      <reg-steps-box
          :text="$lang.messages.activateSubscription"
          :whatStep="subscriptionActivated"
          :isShown="subscriptionActivated"
          :isDisabledClass="subscriptionActivated === 'unfinished'"
      >
      </reg-steps-box>

      <!-- Add your bank account -->
      <reg-steps-box
        :text="$lang.messages.addYourBankAccount"
        :whatStep="bankAccountAdded"
        :isShown="bankAccountAdded"
        :isDisabledClass="bankAccountAdded === 'unfinished'"
      >
      </reg-steps-box>

      <!-- Schedule payment -->
      <reg-steps-box
        :text="$lang.messages.schedulePayments"
        :whatStep="hasScheduledPayments"
        :isShown="hasScheduledPayments"
        :isDisabledClass="hasScheduledPayments === 'unfinished'"
      >
      </reg-steps-box>

      <!-- Setup Parenting schedule -->
      <reg-steps-box
        :text="$lang.messages.setupParentCalendarSchedule"
        :whatStep="hasEventOrVisitations"
        :isShown="hasEventOrVisitations"
        :isDisabledClass="hasEventOrVisitations === 'unfinished'"
      >
      </reg-steps-box>
    </section>
    <img src="@/assets/images/pocket-right.png" alt="before" class="pocket">

  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { GET_REGISTRATION_PROGRESS } from "@/store/action.types";
  import RegistrationStepsBox from "./RegistrationStepsBox";

  export default {
    name: "RegistrationSteps",
    components: {
      'reg-steps-box': RegistrationStepsBox
    },
    data() {
      return {
        intervalProgress: null
      };
    },
    computed: {
      ...mapGetters([
        'currentStep',
        'totalSteps',
        'coparentAdded',
        'childAdded',
        'subscriptionActivated',
        'bankAccountAdded',
        'hasScheduledPayments',
        'hasEventOrVisitations'
      ]),
      /**
       * @description When all of the steps is finished hide the registration wizard
       */
      isRegProgressShown () {
        return !(
          (this.coparentAdded === 'finished' || !this.coparentAdded) &&
          (this.childAdded === 'finished' || !this.childAdded) &&
          (this.subscriptionActivated === 'finished' || !this.subscriptionActivated) &&
          (this.bankAccountAdded === 'finished' || !this.bankAccountAdded) &&
          (this.hasScheduledPayments === 'finished' || !this.hasScheduledPayments) &&
          (this.hasEventOrVisitations === 'finished' || !this.hasEventOrVisitations)
        );
      }
    },
    mounted() {
      this.setScroll();
      this.checkRegProgress();
    },
    beforeDestroy() {
      window.clearInterval(this.intervalProgress)
    },
    methods: {
      ...mapActions({
        getRegistrationProgressAction: GET_REGISTRATION_PROGRESS
      }),
      /**
       * @description Every 10 seconds call /progress endpoint, and
       * remove it when registration progress is done
       */
      checkRegProgress() {
        this.intervalProgress = setInterval(() => {
          if (
            (this.coparentAdded === 'finished' || !this.coparentAdded) &&
            (this.childAdded === 'finished' || !this.childAdded) &&
            (this.subscriptionActivated === 'finished' || !this.subscriptionActivated) &&
            (this.bankAccountAdded === 'finished' || !this.bankAccountAdded) &&
            (this.hasScheduledPayments === 'finished' || !this.hasScheduledPayments) &&
            (this.hasEventOrVisitations === 'finished' || !this.hasEventOrVisitations)
          ) {
            window.clearInterval(this.intervalProgress)
          }
  
          this.getRegistrationProgress();
        }, 5000);
      },
      getRegistrationProgress() {
        if (localStorage.getItem('user')) {
          this.getRegistrationProgressAction()
          .then(() => {
            this.setScroll();
          })
        }
      },
      setScroll() {
        let currentStep = this.$store.getters.currentStep;
        let steps = this.$refs.steps;
        if (steps.children) {
          switch(currentStep) {
            case 1:
              if (steps.children[0])
                steps.scrollLeft = steps.children[0].offsetLeft + 10;
              return;
            case 2:
              if (steps.children[1])
                steps.scrollLeft = steps.children[1].offsetLeft + 10;
              return;
            case 3:
              if (steps.children[2])
                steps.scrollLeft = steps.children[2].offsetLeft + 10;
              return;
            case 4:
              if (steps.children[3])
                steps.scrollLeft = steps.children[3].offsetLeft + 10;
              return;
            case 5:
              if (steps.children[4])
                steps.scrollLeft = steps.children[4].offsetLeft + 10;
              return;
            case 6:
              if (steps.children[5])
                steps.scrollLeft = steps.children[5].offsetLeft + 10;
              return;
            case 7:
              if (steps.children[6])
                steps.scrollLeft = steps.children[6].offsetLeft + 10;
              return;
            default: return;
          }
        }
      }
    },
  }
</script>
